import type { SVGProps } from 'react';
import { useId } from 'react';

export function GhostIcon(props: SVGProps<SVGSVGElement>) {
  const maskId = useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" {...props}>
      <mask id={maskId} maskUnits="userSpaceOnUse" x="10" y="8" width="44" height="46">
        <path
          d="M32 10c-11.6 0-20 8.6-20 20.5V52l6-4 6 4 4-4 4 4 4-4 4 4 6-4 6 4V30.5C52 18.6 43.6 10 32 10Z"
          fill="#fff"
        />
        <circle cx="24" cy="28" r="3.5" fill="#000" />
        <circle cx="40" cy="28" r="3.5" fill="#000" />
        <ellipse cx="32" cy="39" rx="4.5" ry="6" fill="#000" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M32 10c-11.6 0-20 8.6-20 20.5V52l6-4 6 4 4-4 4 4 4-4 4 4 6-4 6 4V30.5C52 18.6 43.6 10 32 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
